<template lang="pug">
el-container.layout
    el-aside(width="180px")
        a(href='')
            img.logo(src='/img/cloud-logo-nav.png')
        el-menu(:default-active="activeIndex", background-color="#fff", text-color="#666", active-text-color="#19A2B6", :router="true")
            template(v-for="item in menu")
                el-submenu.menu-label(v-if="item.child && item.child.length", :index="item.path")
                    template(slot="title")
                        i(:class="item.icon")
                        span {{item.title}}
                    el-menu-item-group
                        template(v-for="(childItem, childIndex) in item.child")
                            el-menu-item(:index="childItem.path") {{childItem.title}}
                el-menu-item.menu-label(v-else, :index="item.path")
                    i(:class="item.icon")
                    span(slot="title") {{item.title}}
            el-divider
            el-menu-item.menu-label(@click.native="jumpTo('/workshop')")
                i.el-icon-question
                span(slot="title") 帮助 

    el-container
        el-header.header(height="90px")
            .header-logo
                span Identity Access Management
            .header-menu
                img.avatar(src="/img/avatar.png")
                el-dropdown.dropdown(trigger="click" @command="handleCommand")
                    span.el-dropdown-link.logout {{ account }}
                        i.el-icon-arrow-down.el-icon--right
                    el-dropdown-menu(slot="dropdown")
                        el-dropdown-item(icon="el-icon-map-location", command="gisportal") 三基平台
                        el-dropdown-item(icon="el-icon-switch-button", command="logout") 退出登录
        el-main.layout-main
            router-view
</template>

<script>
import docCookies from "@/utils/docCookies.js";
import { logout } from "@/services";
export default {
    name: "layout",
    data() {
        return {
            account: "",
            activeIndex: "/dashboard",
            menu: [
                {
                    path: "/dashboard",
                    icon: "el-icon-user-solid",
                    title: "首页"
                },
                {
                    path: "/profile",
                    icon: "el-icon-tickets",
                    title: "个人信息"
                },
                {
                    path: "/settings",
                    icon: "el-icon-setting",
                    title: "管理",
                    child: [
                        {
                            path: "/settings/org",
                            title: "组织"
                        },
                        {
                            path: "/settings/team",
                            title: "团队"
                        },
                        // TODO only orgRole in ["owner", "admin"]
                        {
                            path: "/settings/member",
                            title: "成员"
                        }
                    ]
                }
            ],
            action: []
        };
    },
    methods: {
        async logout() {
            try {
                const res = await logout();
                if (res.status === 204) {
                    docCookies.removeItem(
                        "vsat-iam",
                        "/",
                        window.location.host
                            .split(".")
                            .slice(-2)
                            .join(".")
                    );
                    localStorage.clear();
                    window.location.replace("/login");
                }
            } catch {
                console.log("logout failed");
                this.$message.error("服务器开小差了，请尝试重新操作");
            }
        },
        handleCommand(command) {
            switch (command) {
                case "logout":
                  this.logout();
                case "gisportal":
                  window.location.assign("https://portal.vsat.cloud/console")
                default:
                  break
            } 
        },
        jumpTo(url) {
            window.location.href = url;
        },
        initLocalStorage() {
            if (localStorage.getItem("account") == null) {
                docCookies.removeItem(
                    "vsat-iam",
                    "/",
                    window.location.host
                        .split(".")
                        .slice(-2)
                        .join(".")
                );
                window.location.replace("/login");
            } else {
                this.account = localStorage.getItem("account");
            }
        }
    },
    mounted() {
        this.initLocalStorage();
    },
    beforeUpdate() {
        this.activeIndex = this.$route.meta.activeIndex
            ? this.$route.meta.activeIndex
            : this.$route.matched[1].path;
    }
};
</script>

<style lang="stylus" scoped>
.layout {
    display: flex;
    width: 100%;
    height: 100%;
    background: #ffffff;

    .logo {
        display: block;
        width: 160px;
        padding: 32px 12px;
    }

    .menu {
        height: 100%;
        flex: 0 0 auto;
        border-right: 0px;
    }
}

.header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 18px 20px 10px;
    background: #ffffff;
}

.header-logo {
    span {
        font-size: 24px;
        font-family: Futura;
        font-weight: bold;
        color: #4A4947;
    }
}

.header-menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-basis: 50%;

    .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
    }

    .dropdown {
        margin-top: 10px;
    }

    .logout {
        color: #1EABC1;
        margin-left: 5px;
        font-size: 16px;
    }
}

.menu-label {
    span {
        margin-right: 10px;
    }
}

.layout-main {
    background: #F1F4F9;
}

.el-menu {
    border: none;
}

.el-divider {
    margin: 8px 0;
}
</style>
